<template>
  <router-link class="userBlock" style="display: inline-flex; justify-content: flex-start; align-items: center;"  :to="'/' + dtoUser.userName">
    <!--/*  アバター画像  */-->
    <img
      class="avatar_image" style="border-radius: 50%"
      :src="urls.getUserImageSrc(dtoUser)"
      :alt="dtoUser.displayName"
    />

    <!--/*  名前  */-->
    <div class="userDisplayName">
      {{ dtoUser.displayName }}
    </div>

    <!--/*todo:フォローボタンは一旦、非表示
    <div>
      <FollowButton :dtoUser="dtoUser"></FollowButton>
    </div>
      */-->
  </router-link>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import UserResp from "@/interface/api/UserResp";
import RootVue from "@/RootVue.vue";
import FollowButton from "@/component/parts/FollowButton.vue";
import urls from "@/URLs";


@Options({
  components: {
    FollowButton,
  },
  props: {
    dtoUser: {
      type: Object,
    },
  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;

  readonly dtoUser!: UserResp;
  readonly urls = urls;
  
  get isViewFollowButton() {
    // ログアウト中
    if (!this.$root.account.isLogin) {
      return false;
    }
    return this.$root.account.info.userName != this.dtoUser.userName;
  }
}
</script>
<style lang="scss" scoped>
.userBlock {
  cursor: pointer;
  text-decoration: none;
  color: inherit;
}

.avatar_image {
  width: 50px;
  height: 50px;
}

.userDisplayName {
  padding-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>